// Constants
import { MODAL_CLOSE, MODAL_OPEN, MODAL_SET_STATE } from './modalConstants';

export const modalOpened = (modalName, state) => ({ type: MODAL_OPEN, modalName, state });
export const setModalState = (modalName, state) => ({ type: MODAL_SET_STATE, modalName, state });
export const modalClosed = (modalName) => ({ type: MODAL_CLOSE, modalName });
